
import { select } from "d3-selection";
import { schemeCategory10 } from "d3-scale-chromatic";
import { Vue } from "vue-class-component";
import { Prop, Ref } from "vue-property-decorator";
/* eslint-disable @typescript-eslint/no-explicit-any */
const sortValues = [
  "コミュニケーション力 伝える力",
  "創造・創意工夫力",
  "臨機応変さ",
  "業務遂行力",
  "ストレスコントロール力",
  "リーダーシップ力 メンテナンス",
  "リーダーシップ力 パフォーマンス",
  "コミュニケーション力 調整する力",
  "コミュニケーション力 受け入れる力"
];
const RadarChart = {
  draw: function(id: any, d: any, options: any) {
    const cfg: any = {
      radius: 5,
      w: 250,
      h: 250,
      factor: 1,
      factorLegend: 0.85,
      levels: 5,
      maxValue: 100,
      radians: 2 * Math.PI,
      opacityArea: 0.5,
      ToRight: 5,
      TranslateX: 100,
      TranslateY: 50,
      ExtraWidthX: 200,
      ExtraWidthY: 150,
      color: schemeCategory10
    };

    if ("undefined" !== typeof options) {
      for (const i in options) {
        if ("undefined" !== typeof options[i]) {
          cfg[i] = options[i];
        }
      }
    }
    const allAxis = d[0].map(function(i: any) {
      return i.axis;
    });
    const total = allAxis.length;
    const radius = cfg.factor * Math.min(cfg.w / 2, cfg.h / 2);
    select(id)
      .select("svg")
      .remove();

    const g = select(id)
      .append("svg")
      .attr("width", cfg.w + cfg.ExtraWidthX)
      .attr("height", cfg.h + cfg.ExtraWidthY)
      .append("g")
      .attr("transform", "translate(" + cfg.TranslateX + "," + cfg.TranslateY + ")");
    //Circular segments
    for (let j = 0; j < cfg.levels; j++) {
      const levelFactor = cfg.factor * radius * ((j + 1) / cfg.levels);
      g.selectAll(".levels")
        .data(allAxis)
        .enter()
        .append("svg:line")
        .attr("x1", (_d, i) => levelFactor * (1 - cfg.factor * Math.sin((i * cfg.radians) / total)))
        .attr("y1", (_d, i) => levelFactor * (1 - cfg.factor * Math.cos((i * cfg.radians) / total)))
        .attr("x2", (_d, i) => levelFactor * (1 - cfg.factor * Math.sin(((i + 1) * cfg.radians) / total)))
        .attr("y2", (_d, i) => levelFactor * (1 - cfg.factor * Math.cos(((i + 1) * cfg.radians) / total)))
        .attr("class", "line")
        .style("stroke", "grey")
        .style("stroke-opacity", "0.75")
        .style("stroke-width", "0.3px")
        .attr("transform", "translate(" + (cfg.w / 2 - levelFactor) + ", " + (cfg.h / 2 - levelFactor) + ")");
    }
    for (let j = 0; j < cfg.levels - 1; j++) {
      const levelFactor = cfg.factor * radius * ((j + 1) / cfg.levels);
      g.selectAll(".levels")
        .data([1])
        .enter()
        .append("svg:text")
        .attr("x", () => {
          return levelFactor * (1 - cfg.factor * Math.sin(0));
        })
        .attr("y", () => {
          return levelFactor * (1 - cfg.factor * Math.cos(0));
        })
        .attr("class", "legend")
        .style("font-family", "sans-serif")
        .style("font-size", "8px")
        .attr("transform", "translate(" + (cfg.w / 2 - levelFactor + cfg.ToRight) + ", " + (cfg.h / 2 - levelFactor) + ")")
        .attr("fill", "#b8ccda")
        .text(((j + 1) * 100) / cfg.levels);
    }
    let series = 0;

    const axis = g
      .selectAll(".axis")
      .data(allAxis)
      .enter()
      .append("g")
      .attr("class", "axis");

    axis
      .append("line")
      .attr("x1", cfg.w / 2)
      .attr("y1", cfg.h / 2)
      .attr("x2", (_d, i) => (cfg.w / 2) * (1 - cfg.factor * Math.sin((i * cfg.radians) / total)))
      .attr("y2", (_d, i) => (cfg.h / 2) * (1 - cfg.factor * Math.cos((i * cfg.radians) / total)))
      .attr("class", "line")
      .style("stroke", "#EAF0F4")
      .style("stroke-width", "1px");

    const title = axis.append("text");

    const allValues = d[0].map(function(i: any) {
      return i.value;
    });
    title
      .selectAll("tspan.text")
      .data((d, i) => {
        // @ts-ignore
        const split = d.split(" ") as string[];
        const v = String(Math.round(allValues[i]));
        if (split[1]) {
          split[1] = ` ${split[1]}`;
          split[2] = v;
        } else {
          split[1] = v;
        }
        return split;
      })
      .enter()
      .append("tspan")
      .attr("class", "title")
      .text(d => d)
      .attr("dx", d => {
        return d.indexOf(" ") === 0 ? -90 : -10;
      })
      .attr("dy", "1.1em")
      .style("font-size", "0.7em");

    title
      .attr("class", "legend")
      .attr("text-anchor", "middle")
      .attr("dy", "1.5em")
      .attr("transform", "translate(0, -20)")
      .attr("fill", "#737373")
      .attr("x", (d, i) => {
        return (
          (cfg.w / 2) * (1 - cfg.factorLegend * Math.sin((i * cfg.radians) / total)) - 60 * Math.sin((i * cfg.radians) / total)
        );
      })
      .attr("y", (d, i) => {
        return (cfg.h / 2) * (1 - Math.cos((i * cfg.radians) / total)) - 20 * Math.cos((i * cfg.radians) / total);
      });

    const dataValues: any[] = [];
    d.forEach((y: any) => {
      g.selectAll(".nodes")
        // @ts-ignore
        .data(y, function(j, i) {
          dataValues.push([
            (cfg.w / 2) *
              (1 -
                // @ts-ignore
                (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) * cfg.factor * Math.sin((i * cfg.radians) / total)),
            // @ts-ignore
            (cfg.h / 2) *
              (1 -
                // @ts-ignore
                (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) * cfg.factor * Math.cos((i * cfg.radians) / total))
          ]);
        });
      dataValues.push(dataValues[0]);
      g.selectAll(".area")
        .data([dataValues])
        .enter()
        .append("polygon")
        .attr("class", "radar-chart-serie" + series)
        .style("stroke-width", "1px")
        .style("stroke", "#A3A0FB")
        .attr("points", d => {
          let str = "";
          for (let pti = 0; pti < d.length; pti++) {
            str = str + d[pti][0] + "," + d[pti][1] + " ";
          }
          return str;
        })
        .style("fill", "#567ec4")
        .style("fill-opacity", "0%");
      series++;
    });
    series = 0;
  }
};
export default class HumanSkillChart extends Vue {
  @Ref("container") readonly container!: HTMLElement;
  @Prop({ type: Array, required: true }) readonly chartData!: {
    name: string;
    value: number;
  }[];
  draw() {
    const d = [
      this.chartData
        .map(c => ({ axis: c.name, value: c.value }))
        .sort((x, y) => {
          return sortValues.indexOf(x.axis) - sortValues.indexOf(y.axis);
        })
    ];
    RadarChart.draw(this.container, d, {});
  }
  updated() {
    this.draw();
  }
  mounted() {
    this.draw();
  }
}
/* eslint-enable */
